module.exports = __webpack_public_path__ + "static/img/enterShenhe.f85a428.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/enterFor/enterShenhe.png
// module id = qhpB
// module chunks = 0